import { useEffect, useState } from 'react';

import { useNavigate } from 'react-router-dom';
import { toast } from 'react-toastify';

import { useFormikForm } from '#/common/hooks';
import { ROUTES } from '#/routes';
import { apiEndpoints, usePostMutation } from '#/services';
import {
    ACCESS_TOKEN,
    IMAGE_SIZE,
    TeamMemberValidationSchema,
    getLocalStorageItem,
    getSessionStorageItem,
    teamMemberInInitialValues,
} from '#/utils';

export function useMemberLogin({ isThriveCart }) {
    const navigate = useNavigate();

    const [imagePreview, setImagePreview] = useState(null);

    const { mutate: inviteMemberApiCall, isPending: inviteMemberApiLoading } = usePostMutation({
        url: isThriveCart ? apiEndpoints.ACCEPT_THRIVE_CARD_INVITE : apiEndpoints.ACCEPT_TEAM_INVITE,
        onSuccess: inviteMemberCallSuccess,
        successMessage: 'Invitation accepted successfully.',
    });

    function inviteMemberCallSuccess() {
        navigate(ROUTES.LOGIN);
    }

    const handleInviteMember = async values => {
        const formData = new FormData();
        formData.append('first_name', values?.firstName);
        formData.append('last_name', values?.lastName);
        formData.append('password', values?.password);
        formData.append('confirm_password', values?.password);
        formData.append('profile_picture', values?.profilePicture);
        formData.append('token', values?.token);

        inviteMemberApiCall({
            payload: formData,
        });
    };

    const handleImage = e => {
        const file = e.target.files[0];
        const validTypes = ['image/jpg', 'image/png', 'image/jpeg'];

        if (file) {
            if (file.size > IMAGE_SIZE) {
                toast.warn('File size should be less than 1MB');
            } else if (!validTypes.includes(file.type)) {
                toast.warn('Only JPG, JPEG and PNG formats are allowed');
            } else {
                setInviteValues('profilePicture', file);
                const imageURL = URL.createObjectURL(file);
                setImagePreview(imageURL);
            }
        }
    };

    const {
        handleChange: handleChangeInvite,
        handleSubmit: handleSubmitInvite,
        errors: inviteErrors,
        touched: inviteTouched,
        values: inviteValues,
        setFieldValue: setInviteValues,
    } = useFormikForm(teamMemberInInitialValues, handleInviteMember, TeamMemberValidationSchema);

    useEffect(() => {
        if (getLocalStorageItem(ACCESS_TOKEN) || getSessionStorageItem(ACCESS_TOKEN)) navigate(ROUTES.HOME);
    }, []);
    return {
        handleChangeInvite,
        handleSubmitInvite,
        inviteErrors,
        inviteTouched,
        inviteValues,
        setInviteValues,
        imagePreview,
        handleImage,
        inviteMemberApiLoading,
    };
}
